define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/reflection",
	"csi/util",
	"csi/xml"
], function(def, Action, ActionFactory, reflection, util, xml) {

	return ActionFactory.declare("NewFrom", Action, {
		// String: default tag for action
		m_tag: "NewFrom",

		constructor: function(obj) {
			this.m_typeNodeHint = util.getProperty(obj, "Type", "");			// optional hint to name action
			this.idForm = util.getProperty(obj, "Form", def.DEFAULT_FORM_ID);	// optional form to show for each selection

			// set defaults for action if not explicitly configured
			this.m_id = this.m_id || (this.m_tag + this.m_typeNodeHint);
			this.setBaseRights(null, xml.RIGHT_WRITE);
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: if the type of Node is known, make sure it's not abstract
			var rc = reflection.getClass(this.m_typeNodeHint);

			if (!rc && this.m_relationship) {
				rc = this.m_relationship.getTargetClass();
			}

			if (rc?.disabled) {
				return false;
			}

			return this.inherited(arguments);
		},

		_getNameParams: function(/*csi.LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			return [lr.getTypeName(this.m_typeNodeHint)];
		}
	});
});